export const PXStats = (function() {
	'use strict';

	var statValues;

	function init() {
		events();
	}

	function events() {


		statValues = document.querySelectorAll('.pxblock--stats .circle__number');
		statValues.forEach((stat) => {
            const statValue = stat.innerHTML;

            const od = new Odometer({
                el: stat,
                value: 0,
                theme: 'default'
            });

            const options = {
                threshold: 0.75
            };

            function handleIntersection(entries) {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        od.update(statValue);
                    }
                });
            }

            const observer = new IntersectionObserver(handleIntersection, options);
            observer.observe(stat);
        });
	}

	return {
		init: init
	};
})();
